var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicatorMoved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.9072C2.39648 11.8571 2.67676 11.7135 2.84082 11.4766C3.00944 11.2396 3.21452 10.6927 3.45605 9.83594L5.17188 3.79297C5.22656 3.58789 5.13314 3.44434 4.8916 3.3623C4.65462 3.27572 4.40169 3.23014 4.13281 3.22559V3H6.68262L7.44141 9.83594H7.48926L12.1582 3H14.4893V3.22559C14.1201 3.27116 13.8649 3.34863 13.7236 3.45801C13.5869 3.56283 13.4593 3.82943 13.3408 4.25781L11.625 10.4512C11.5749 10.6289 11.5339 10.7861 11.502 10.9229C11.4746 11.0596 11.4609 11.1826 11.4609 11.292C11.4609 11.5381 11.5452 11.6999 11.7139 11.7773C11.887 11.8503 12.165 11.8936 12.5479 11.9072V12.1328H8.71973V11.9072C9.1071 11.8753 9.38281 11.8161 9.54688 11.7295C9.82031 11.5791 10.014 11.2943 10.1279 10.875L11.9121 4.3877H11.8643L6.66211 12.1328H6.42285L5.5752 4.63379H5.52734L3.92773 10.5469C3.89583 10.6745 3.86621 10.8066 3.83887 10.9434C3.81152 11.0801 3.79785 11.1872 3.79785 11.2646C3.79785 11.5153 3.90495 11.6908 4.11914 11.791C4.25586 11.8548 4.47689 11.8936 4.78223 11.9072V12.1328H2V11.9072Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorMoved);
export default __webpack_public_path__ + "static/media/Indicator-Moved.d039ad5a2fcf156c90a48bc7db28a85d.svg";
export { ForwardRef as ReactComponent };